import React from 'react'
import "./ExploreMenu.css"
import { menu_list } from '../../assets/assets'

function ExploreMenu(props) {
  const { category, setCategory } = props;

  return (
    <div className='explore-menu' id="explore-menu">
      <h1>Explore our menu</h1>
      <p className='explore-menu-text'>
        Dive into a culinary adventure with our diverse menu! From mouth-watering appetizers to delectable desserts, each dish is crafted with the finest ingredients to tantalize your taste buds. Discover your favorites and indulge in a feast like no other.
      </p>
      <div className="explore-menu-list">
        {menu_list.map((item, index) => {
          return (
            <div 
              key={index} className="explore-menu-list-item"
              onClick={() => setCategory(prev => prev === item.menu_name ? "All" : item.menu_name)}
            >
              <img className={category === item.menu_name ? "active" : ""} src={item.menu_image} alt="" />
              <p>{item.menu_name}</p>
            </div>
          )
        })}
      </div>
      <hr />
    </div>
  )
}

export default ExploreMenu
